import api from '@/services/api';

export const WIDGET_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  EMPTY: 'empty',
  REFRESHING: 'refreshing',
};

const defaultWidget = () => ({ status: WIDGET_STATUS.IDLE, data: null });

const requestSeq = {};

function manageFetch(name, commit, state, fetchFn, force = false) {
  const current = state.widgets[name] || defaultWidget();
  const { status } = current;

  if ((status === WIDGET_STATUS.SUCCESS || status === WIDGET_STATUS.LOADING) && !force) {
    return Promise.resolve(current.data);
  }

  const nextStatus = status === WIDGET_STATUS.SUCCESS
    ? WIDGET_STATUS.REFRESHING
    : WIDGET_STATUS.LOADING;

  requestSeq[name] = (requestSeq[name] || 0) + 1;
  const seq = requestSeq[name];

  commit('setWidgetStatus', { name, status: nextStatus });

  return fetchFn()
    .then((data) => {
      if (requestSeq[name] !== seq) return data;
      const resolved = data && data.length > 0 ? WIDGET_STATUS.SUCCESS : WIDGET_STATUS.EMPTY;
      commit('setWidgetData', { name, data, status: resolved });
      return data;
    })
    .catch(() => {
      if (requestSeq[name] !== seq) return;
      commit('setWidgetStatus', { name, status: WIDGET_STATUS.ERROR });
    });
}

export default {
  namespaced: true,
  state: {
    widgets: {},
  },
  getters: {
    getWidget: state => name => state.widgets[name] || defaultWidget(),
  },
  mutations: {
    setWidgetStatus(state, { name, status }) {
      state.widgets = {
        ...state.widgets,
        [name]: { ...(state.widgets[name] || defaultWidget()), status },
      };
    },
    setWidgetData(state, { name, data, status }) {
      state.widgets = {
        ...state.widgets,
        [name]: { data, status },
      };
    },
  },
  actions: {
    fetchNewArrivals({ commit, state }, { limit = 5, force = false } = {}) {
      return manageFetch(
        'new-arrivals',
        commit,
        state,
        () => api.browse.getNewArrivalMarkets(limit).then(r => r.data.markets || r.data),
        force,
      );
    },
    fetchBiggestGains({ commit, state }, { force = false } = {}) {
      return manageFetch(
        'biggest-gains',
        commit,
        state,
        () => api.browse.getHomePageGainModule(false, 1, 2).then((r) => {
          r.data.forEach((el) => {
            el.isGain = true;
          });
          return r.data;
        }),
        force,
      );
    },
    fetchBiggestLoss({ commit, state }, { force = false } = {}) {
      return manageFetch(
        'biggest-losses',
        commit,
        state,
        () => api.browse.getHomePageGainModule(true, 1, 2).then((r) => {
          r.data.forEach((el) => {
            el.isGain = false;
          });
          return r.data;
        }),
        force,
      );
    },
    fetchMyShares({ commit, state }, { sort, sortParameter, force = false } = {}) {
      return manageFetch(
        'portfolio',
        commit,
        state,
        () => api.profile.getMyShares(sort, sortParameter).then(r => r.data.markets || r.data),
        force,
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/widgets.js